import React from 'react';
import { TypedMemo } from '../../../../common/types';
import { withBrandWord } from '../../../components/primitives/BrandWord';

interface ProfileToolSwitchProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** One switch of the preview rail (design `.tg`): Bootstrap `form-switch`. */
const ProfileToolSwitchComponent: React.FC<ProfileToolSwitchProps> = ({ id, label, checked, onChange }) => (
  <div className="form-check form-switch m-0">
    <input
      id={id}
      type="checkbox"
      className="form-check-input"
      checked={checked}
      data-testid={id}
      onChange={(event) => onChange(event.currentTarget.checked)}
    />
    <label className="form-check-label" htmlFor={id}>
      {withBrandWord(label)}
    </label>
  </div>
);

export const ProfileToolSwitch = TypedMemo(ProfileToolSwitchComponent);
